import React, {Component} from 'react';
import {connect} from 'react-redux';
import {AccessRights} from '../../../schemas/accessRightsModel';
import {showSwitchUserWindow, getProtectedAreasByUser} from "../../../actions/auth";
import {getEnabledEntities, selectEnabledEntity, appSetAsCustomer} from "../../../actions/customers";
import PropTypes from 'prop-types';
import template from '../../../templates/PageLayout/Popups/SwitchUserPopup.rt';
import debounce from 'lodash/debounce';
import { hashHistory } from 'react-router';
import {setNotificationsReceived, setNotificationsRequested} from "../../../actions/dashboardFunctions";
import {setFiltersPopupResponse} from "../../JobBoard/jobBoardFilters/JobBoardFiltersActions";

class ShowSwitchUserPopup extends Component {
  static propTypes = {
    hide: PropTypes.func.isRequired,
    getEnabledEntities: PropTypes.func.isRequired,
    selectEnabledEntity: PropTypes.func.isRequired,
    appSetAsCustomer: PropTypes.func.isRequired,
    getProtectedAreasByUser: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      searchText: '',
      entity: null
    };

    this.debouncedSearch = debounce(this.doSearch, 1350);
  }

  componentDidMount() {
    this.props.getEnabledEntities();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.statusUpdateSuccess) {

    }
  }

  doSearch = (term) => {
    this.props.getEnabledEntities(0, term);
  }

  handleSearchTextChanged = (e) => {
    const {value} = e.target;
    this.setState({searchText: value}, () => {
      this.debouncedSearch(value);
    });
  }

  setCustomer = () => {
    this.props.hide();
    this.props.appSetAsCustomer(true);
    this.props.getProtectedAreasByUser(this.state.entity.id, this.state.entity.customerBaseId);
    this.props.setNotificationsRequested(false);
    this.props.setNotificationsReceived(false);
    this.props.clearFiltersPopupCustomersAndStores();
  }

  isSelectedEntity = (entity, asCustomer) => {
    return (asCustomer.id === entity.id) && (asCustomer.customerBaseId === entity.customerBaseId)
      && (asCustomer.dashboardEntity === entity.dashboardEntity)
  };

  setEntity = entity => {
    this.setState({entity});
    this.props.selectEnabledEntity(entity);
  }

  setEntityAndApply = entity => {
    this.setEntity(entity);
    this.setCustomer();
  };

  handlePageClick = (page) => {
    this.props.getEnabledEntities(page - 1, this.props.term);
  }

  handleCancelClick = () => {
    this.props.selectEnabledEntity(null);
    this.props.hide();
  }

  handleResetClick = () => {
    this.props.appSetAsCustomer(false);
    this.props.setNotificationsRequested(false);
    this.props.setNotificationsReceived(false);
    this.props.clearFiltersPopupCustomersAndStores();
    this.props.hide();
    hashHistory.push('/');
  }

  render = template
}

function mapDispatchToProps(dispatch) {
  return {
    hide: () => dispatch(showSwitchUserWindow(false)),
    getEnabledEntities: (page, term) => dispatch(getEnabledEntities(page, term)),
    selectEnabledEntity: (entity) => dispatch(selectEnabledEntity(entity)),
    appSetAsCustomer: (set) => dispatch(appSetAsCustomer(set)),
    setNotificationsRequested: (notificationsRequested) => dispatch(setNotificationsRequested(notificationsRequested)),
    setNotificationsReceived: (notificationsReceived) => dispatch(setNotificationsReceived(notificationsReceived)),
    getProtectedAreasByUser: (userId, customerBaseId) => dispatch(getProtectedAreasByUser(userId, customerBaseId, true)),
    clearFiltersPopupCustomersAndStores: () => dispatch(setFiltersPopupResponse(false)),
  };
}

function mapStateToProps(state) {
  const {asCustomer} = state;
  const {customers} = state;
  const {enabledEntities} = customers;
  return {
    ...asCustomer,
    AR: AccessRights.get(state),
    ...enabledEntities,
    loading: customers.enabledEntities ? customers.enabledEntities.loading : false,
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(ShowSwitchUserPopup);
